import { SlotMachineOutlineIcon } from './SlotMachineOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 5A083823-77FD-4C5E-98B8-EF320E8493CD
 * name slot-machine-outline
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/slot-machine-outline.svg
 * tags
 */
export const GamblingOutlineIcon = SlotMachineOutlineIcon;
export default GamblingOutlineIcon